var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _vm.server.app_info
        ? _c("kvm-app-info", {
            staticClass: "mb-6",
            attrs: {
              "app-info": _vm.server.app_info,
              "app-name": _vm.server.app
            }
          })
        : _vm._e(),
      _c(
        "gg-card",
        {
          staticClass: "mb-6"
        },
        [
          _c(
            "gg-card-text",
            {
              staticClass: "pa-4"
            },
            [
              _c(
                "div",
                {
                  staticClass: "d-flex flex-wrap align-center mb-4"
                },
                [
                  _c("kvm-logo", {
                    staticClass: "mr-3",
                    attrs: {
                      item: {
                        os: _vm.server.os
                      },
                      size: 40,
                      "default-icon": "mdi-server"
                    }
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "mr-4"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "body-1 font-weight-medium"
                        },
                        [_vm._v(_vm._s(_vm.server.os))]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "mt-1"
                        },
                        [
                          _c(
                            "v-chip",
                            {
                              staticClass: "mr-1",
                              attrs: {
                                "x-small": "",
                                label: ""
                              }
                            },
                            [_vm._v(_vm._s(_vm.server.plan))]
                          ),
                          _c(
                            "v-icon",
                            {
                              staticClass: "pb-1",
                              attrs: {
                                small: "",
                                color: _vm.statusChip.color,
                                "aria-hidden": "true"
                              }
                            },
                            [_vm._v("mdi-circle")]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "pl-1 text-body-2"
                            },
                            [_vm._v(_vm._s(_vm.statusChip.text))]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "mr-auto my-2"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "vds-sublabel text-body-2 font-weight-bold"
                        },
                        [_vm._v("Root access")]
                      ),
                      _c("kvm-copyable", {
                        attrs: {
                          value: _vm.sshCommand,
                          display: _vm.sshCommand
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-dialog",
                {
                  attrs: {
                    "max-width": "480"
                  },
                  model: {
                    value: _vm.hostnameDialog.open,
                    callback: function callback($$v) {
                      _vm.$set(_vm.hostnameDialog, "open", $$v)
                    },
                    expression: "hostnameDialog.open"
                  }
                },
                [
                  _c(
                    "v-card",
                    {
                      attrs: {
                        role: "dialog",
                        "aria-modal": "true",
                        "aria-labelledby": "kvm-hostname-dialog-title"
                      }
                    },
                    [
                      _c(
                        "v-card-title",
                        {
                          staticClass: "body-1 font-weight-medium",
                          attrs: {
                            id: "kvm-hostname-dialog-title"
                          }
                        },
                        [_vm._v("Change hostname")]
                      ),
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "p",
                            {
                              staticClass: "mb-3"
                            },
                            [
                              _vm._v(
                                " The server's own name, set on it right away. A rebuild keeps it. Use letters, numbers and hyphens, optionally with dots (e.g. "
                              ),
                              _c("code", [_vm._v("web1")]),
                              _vm._v(" or "),
                              _c("code", [_vm._v("web1.example.com")]),
                              _vm._v("). ")
                            ]
                          ),
                          _c("v-text-field", {
                            attrs: {
                              label: "Hostname",
                              outlined: "",
                              dense: "",
                              autocomplete: "off",
                              spellcheck: "false",
                              rules: [
                                function(v) {
                                  return (
                                    _vm.hostnameValid(v) ||
                                    "Not a valid hostname."
                                  )
                                }
                              ]
                            },
                            on: {
                              keyup: function keyup($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                _vm.hostnameValid(_vm.hostnameDialog.value) &&
                                  _vm.saveHostname()
                              }
                            },
                            model: {
                              value: _vm.hostnameDialog.value,
                              callback: function callback($$v) {
                                _vm.$set(
                                  _vm.hostnameDialog,
                                  "value",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "hostnameDialog.value"
                            }
                          }),
                          !_vm.serverRunning
                            ? _c(
                                "p",
                                {
                                  staticClass: "text-caption mb-0"
                                },
                                [
                                  _vm._v(
                                    "The server must be running to change its hostname."
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.hostnameDialog.error
                            ? _c(
                                "v-alert",
                                {
                                  staticClass: "vds-form-alert mt-2 mb-0",
                                  attrs: {
                                    dense: "",
                                    text: "",
                                    type: "warning",
                                    role: "alert"
                                  }
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.hostnameDialog.error) + " "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "v-card-actions",
                        {
                          staticClass: "px-4 pb-4"
                        },
                        [
                          _c("v-spacer"),
                          _c(
                            "gg-btn",
                            {
                              staticClass: "vds-dialog-btn",
                              attrs: {
                                text: "",
                                disabled: _vm.hostnameDialog.saving
                              },
                              on: {
                                click: function click($event) {
                                  _vm.hostnameDialog.open = false
                                }
                              }
                            },
                            [_vm._v("Cancel")]
                          ),
                          _c(
                            "gg-btn",
                            {
                              staticClass: "vds-dialog-btn",
                              attrs: {
                                tile: "",
                                color: "primary",
                                loading: _vm.hostnameDialog.saving,
                                disabled:
                                  !_vm.serverRunning ||
                                  !_vm.hostnameValid(_vm.hostnameDialog.value)
                              },
                              on: {
                                click: _vm.saveHostname
                              }
                            },
                            [_vm._v("Change")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-dialog",
                {
                  attrs: {
                    "max-width": "480",
                    persistent: ""
                  },
                  model: {
                    value: _vm.passwordDialog,
                    callback: function callback($$v) {
                      _vm.passwordDialog = $$v
                    },
                    expression: "passwordDialog"
                  }
                },
                [
                  _c(
                    "v-card",
                    {
                      attrs: {
                        role: "dialog",
                        "aria-modal": "true",
                        "aria-labelledby": "kvm-pwd-dialog-title"
                      }
                    },
                    [
                      _c(
                        "v-card-title",
                        {
                          staticClass: "body-1 font-weight-medium",
                          attrs: {
                            id: "kvm-pwd-dialog-title"
                          }
                        },
                        [_vm._v("Change root password")]
                      ),
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "p",
                            {
                              staticClass: "mb-3"
                            },
                            [
                              _vm._v(" Set a new root password for "),
                              _c("strong", [
                                _vm._v(_vm._s(_vm.server.hostname))
                              ]),
                              _vm._v(
                                ". The current password stops working once this is applied. "
                              )
                            ]
                          ),
                          _c("v-text-field", {
                            attrs: {
                              type: _vm.reveal ? "text" : "password",
                              label: "New root password",
                              outlined: "",
                              dense: "",
                              counter: 128,
                              rules: _vm.passwordRules,
                              autocomplete: "new-password",
                              "persistent-hint": "",
                              hint: "8–128 characters."
                            },
                            on: {
                              keyup: function keyup($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                _vm.passwordValid && _vm.resetPassword()
                              }
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "append",
                                fn: function fn() {
                                  return [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "mr-2 vds-icon-btn",
                                        attrs: {
                                          small: "",
                                          title: _vm.reveal
                                            ? "Hide password"
                                            : "Reveal password",
                                          "aria-label": _vm.reveal
                                            ? "Hide password"
                                            : "Reveal password",
                                          "aria-pressed": _vm.reveal
                                            ? "true"
                                            : "false"
                                        },
                                        on: {
                                          click: function click($event) {
                                            _vm.reveal = !_vm.reveal
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.reveal
                                                ? "mdi-eye-off"
                                                : "mdi-eye"
                                            ) +
                                            " "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "vds-icon-btn",
                                        attrs: {
                                          small: "",
                                          title: "Copy password",
                                          "aria-label": "Copy password"
                                        },
                                        on: {
                                          click: _vm.copyPassword
                                        }
                                      },
                                      [_vm._v("mdi-content-copy")]
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ]),
                            model: {
                              value: _vm.password,
                              callback: function callback($$v) {
                                _vm.password = $$v
                              },
                              expression: "password"
                            }
                          }),
                          _c(
                            "gg-btn",
                            {
                              staticClass: "px-1 vds-dialog-btn",
                              attrs: {
                                text: "",
                                small: "",
                                color: "primary"
                              },
                              on: {
                                click: _vm.generatePassword
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  attrs: {
                                    left: "",
                                    small: "",
                                    "aria-hidden": "true"
                                  }
                                },
                                [_vm._v("mdi-auto-fix")]
                              ),
                              _vm._v("Generate strong password ")
                            ],
                            1
                          ),
                          _c("v-checkbox", {
                            staticClass: "mt-3",
                            attrs: {
                              dense: "",
                              "hide-details": "",
                              label:
                                "Allow a brief reboot to apply the password if required"
                            },
                            model: {
                              value: _vm.allowReboot,
                              callback: function callback($$v) {
                                _vm.allowReboot = $$v
                              },
                              expression: "allowReboot"
                            }
                          }),
                          _c(
                            "p",
                            {
                              staticClass:
                                "vds-metric__sub text-caption mt-1 mb-0"
                            },
                            [
                              _vm._v(
                                " Applies instantly when the guest agent is responding. If it isn't, applying the password needs a brief restart — only performed if you allow it above. "
                              )
                            ]
                          ),
                          _vm.formError
                            ? _c(
                                "v-alert",
                                {
                                  staticClass: "vds-form-alert mt-3 mb-0",
                                  attrs: {
                                    dense: "",
                                    text: "",
                                    type: "warning",
                                    role: "alert"
                                  }
                                },
                                [_vm._v(" " + _vm._s(_vm.formError) + " ")]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "v-card-actions",
                        {
                          staticClass: "px-4 pb-4"
                        },
                        [
                          _c("v-spacer"),
                          _c(
                            "gg-btn",
                            {
                              staticClass: "vds-dialog-btn",
                              attrs: {
                                text: "",
                                disabled: _vm.resetting
                              },
                              on: {
                                click: _vm.closePasswordDialog
                              }
                            },
                            [_vm._v("Cancel")]
                          ),
                          _c(
                            "gg-btn",
                            {
                              staticClass: "vds-dialog-btn",
                              attrs: {
                                tile: "",
                                color: "primary",
                                loading: _vm.resetting,
                                disabled: !_vm.passwordValid
                              },
                              on: {
                                click: _vm.resetPassword
                              }
                            },
                            [_vm._v(" Set password ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                {
                  attrs: {
                    dense: ""
                  }
                },
                [
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12",
                        sm: "6",
                        md: "4"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "vds-metric pa-3 d-flex flex-column"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "vds-metric__label text-caption mb-1"
                            },
                            [_vm._v("CPU usage")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "text-h6 font-weight-bold"
                            },
                            [_vm._v(_vm._s(_vm.server.cpu_used_percent) + "%")]
                          ),
                          _vm.cpuSeries.length
                            ? _c("kvm-sparkline", {
                                staticClass: "mt-auto pt-2",
                                attrs: {
                                  value: _vm.cpuSeries,
                                  color: _vm.primaryColor
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12",
                        sm: "6",
                        md: "4"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "vds-metric pa-3 d-flex flex-column"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "vds-metric__label text-caption mb-1"
                            },
                            [_vm._v("Memory usage")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "text-h6 font-weight-bold"
                            },
                            [_vm._v(_vm._s(_vm.memPercent) + "%")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "vds-metric__sub text-caption"
                            },
                            [_vm._v(_vm._s(_vm.memUsage))]
                          ),
                          _vm.memSeries.length
                            ? _c("kvm-sparkline", {
                                staticClass: "mt-auto pt-2",
                                attrs: {
                                  value: _vm.memSeries,
                                  color: _vm.primaryColor
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12",
                        sm: "6",
                        md: "4"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "vds-metric pa-3 d-flex flex-column"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "vds-metric__label text-caption mb-1"
                            },
                            [
                              _vm._v("Traffic "),
                              _c(
                                "span",
                                {
                                  staticClass: "vds-metric__sub"
                                },
                                [_vm._v("· since last boot")]
                              )
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "d-flex flex-wrap"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "mr-4"
                                },
                                [
                                  _c("span", {
                                    staticClass: "vds-legend-dot",
                                    style: {
                                      background: _vm.primaryColor
                                    },
                                    attrs: {
                                      "aria-hidden": "true"
                                    }
                                  }),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "text-h6 font-weight-bold"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.kvmSize(_vm.server.net_in))
                                      )
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "vds-metric__sub text-caption ml-1"
                                    },
                                    [_vm._v("in")]
                                  )
                                ]
                              ),
                              _c("div", [
                                _c("span", {
                                  staticClass: "vds-legend-dot",
                                  style: {
                                    background: _vm.trafficOutColor
                                  },
                                  attrs: {
                                    "aria-hidden": "true"
                                  }
                                }),
                                _c(
                                  "span",
                                  {
                                    staticClass: "text-h6 font-weight-bold"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.kvmSize(_vm.server.net_out))
                                    )
                                  ]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "vds-metric__sub text-caption ml-1"
                                  },
                                  [_vm._v("out")]
                                )
                              ])
                            ]
                          ),
                          _vm.netinSeries.length || _vm.netoutSeries.length
                            ? _c("kvm-dual-sparkline", {
                                staticClass: "mt-auto pt-2",
                                attrs: {
                                  a: _vm.netinSeries,
                                  b: _vm.netoutSeries,
                                  "color-a": _vm.primaryColor,
                                  "color-b": _vm.trafficOutColor
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        {
          staticClass: "mb-6",
          attrs: {
            dense: ""
          }
        },
        _vm._l(_vm.actionTiles, function(t) {
          return _c(
            "v-col",
            {
              key: t.title,
              attrs: {
                cols: "12",
                sm: "6",
                md: "4"
              }
            },
            [
              _c(
                "gg-card",
                {
                  staticClass: "vds-tile",
                  attrs: {
                    to: {
                      name: t.route,
                      params: {
                        hostingid: _vm.server.id
                      }
                    }
                  }
                },
                [
                  _c(
                    "gg-card-text",
                    {
                      staticClass: "d-flex align-center pa-3"
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticClass: "mr-3",
                          attrs: {
                            color: "primary",
                            "aria-hidden": "true"
                          }
                        },
                        [_vm._v(_vm._s(t.icon))]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "mr-auto"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "body-2 font-weight-medium"
                            },
                            [_vm._v(_vm._s(t.title))]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "vds-tile__sub text-caption"
                            },
                            [_vm._v(_vm._s(t.sub))]
                          )
                        ]
                      ),
                      _c(
                        "v-icon",
                        {
                          attrs: {
                            small: "",
                            "aria-hidden": "true"
                          }
                        },
                        [_vm._v("mdi-chevron-right")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        }),
        1
      ),
      _c(
        "v-row",
        {
          staticClass: "mb-2"
        },
        [
          _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "gg-card",
                [
                  _c(
                    "gg-card-text",
                    {
                      staticClass: "pa-4"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "body-1 mb-4",
                          attrs: {
                            role: "heading",
                            "aria-level": "2"
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "pb-1",
                              attrs: {
                                size: "24",
                                color: "primary",
                                "aria-hidden": "true"
                              }
                            },
                            [_vm._v("mdi-server")]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "ml-2 font-weight-medium"
                            },
                            [_vm._v("VPS Details")]
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        _vm._l(_vm.columns(_vm.vpsDetails), function(col, ci) {
                          return _c(
                            "v-col",
                            {
                              key: ci,
                              class:
                                ci === 0
                                  ? "pl-4 pr-md-9 py-0"
                                  : "pl-md-9 pr-4 py-0",
                              attrs: {
                                cols: "12",
                                md: "6"
                              }
                            },
                            _vm._l(col, function(row) {
                              return _c(
                                "div",
                                {
                                  key: row.label,
                                  staticClass:
                                    "d-flex align-center vds-detail-row"
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "font-weight-bold mr-auto"
                                    },
                                    [_vm._v(_vm._s(row.label) + ":")]
                                  ),
                                  row.rootPassword
                                    ? [
                                        _vm.rootPw.loading
                                          ? _c("v-progress-circular", {
                                              attrs: {
                                                indeterminate: "",
                                                size: "14",
                                                width: "2",
                                                color: "primary",
                                                "aria-label":
                                                  "Loading the root password"
                                              }
                                            })
                                          : [
                                              _vm.rootPw.shown
                                                ? _c("kvm-copyable", {
                                                    attrs: {
                                                      value: _vm.rootPw.value,
                                                      display: _vm.rootPw.value
                                                    }
                                                  })
                                                : _vm.rootPw.available === false
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "vds-detail__value--muted"
                                                    },
                                                    [_vm._v("Not on file")]
                                                  )
                                                : _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "vds-rootpw-mask"
                                                    },
                                                    [_vm._v("••••••••••••")]
                                                  ),
                                              _vm.rootPw.shown &&
                                              _vm.rootPw.current === false
                                                ? _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "ml-1",
                                                      attrs: {
                                                        small: "",
                                                        color: "warning",
                                                        title:
                                                          "This password was changed on the server itself, so it may no longer work. Use Change to set a new one.",
                                                        "aria-label":
                                                          "Changed on the server — may no longer work"
                                                      }
                                                    },
                                                    [_vm._v("mdi-alert")]
                                                  )
                                                : _vm._e(),
                                              _vm.rootPw.error
                                                ? _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "ml-1",
                                                      attrs: {
                                                        small: "",
                                                        color: "warning",
                                                        title: _vm.rootPw.error,
                                                        "aria-label":
                                                          _vm.rootPw.error
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "mdi-alert-circle-outline"
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "gg-btn",
                                                {
                                                  staticClass: "ml-1",
                                                  attrs: {
                                                    icon: "",
                                                    "x-small": "",
                                                    "aria-label":
                                                      _vm.rootPwButton.label,
                                                    title: _vm.serverRunning
                                                      ? _vm.rootPwButton.label
                                                      : "The server must be running to show its root password",
                                                    disabled:
                                                      !_vm.serverRunning &&
                                                      !_vm.rootPw.shown
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.toggleRootPassword
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        "x-small": ""
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.rootPwButton.icon
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm.rootPw.available !== false
                                                ? _c(
                                                    "gg-btn",
                                                    {
                                                      staticClass: "ml-1",
                                                      attrs: {
                                                        icon: "",
                                                        "x-small": "",
                                                        "aria-label":
                                                          "Copy root password",
                                                        title:
                                                          _vm.serverRunning ||
                                                          _vm.rootPw.value
                                                            ? "Copy"
                                                            : "The server must be running to copy its root password",
                                                        disabled:
                                                          !_vm.serverRunning &&
                                                          !_vm.rootPw.value
                                                      },
                                                      on: {
                                                        click:
                                                          _vm.copyRootPassword
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            "x-small": ""
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "mdi-content-copy"
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "vds-link-btn primary--text ml-3",
                                            attrs: {
                                              type: "button",
                                              "aria-haspopup": "dialog"
                                            },
                                            on: {
                                              click: _vm.openPasswordDialog
                                            }
                                          },
                                          [_vm._v("Change")]
                                        )
                                      ]
                                    : row.hostname
                                    ? [
                                        _c("kvm-copyable", {
                                          attrs: {
                                            value: row.value,
                                            "icon-start": ""
                                          }
                                        }),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "vds-link-btn primary--text ml-3",
                                            attrs: {
                                              type: "button",
                                              "aria-haspopup": "dialog"
                                            },
                                            on: {
                                              click: _vm.openHostnameDialog
                                            }
                                          },
                                          [_vm._v("Change")]
                                        )
                                      ]
                                    : row.copy
                                    ? _c("kvm-copyable", {
                                        attrs: {
                                          value: row.value,
                                          "icon-start": ""
                                        }
                                      })
                                    : _c(
                                        "span",
                                        {
                                          class: {
                                            "vds-detail__value--muted":
                                              row.muted
                                          }
                                        },
                                        [_vm._v(_vm._s(row.value))]
                                      )
                                ],
                                2
                              )
                            }),
                            0
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "gg-card",
                [
                  _c(
                    "gg-card-text",
                    {
                      staticClass: "pa-4"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "body-1 mb-4",
                          attrs: {
                            role: "heading",
                            "aria-level": "2"
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "pb-1",
                              attrs: {
                                size: "24",
                                color: "primary",
                                "aria-hidden": "true"
                              }
                            },
                            [_vm._v("mdi-account-settings")]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "ml-2 font-weight-medium"
                            },
                            [_vm._v("Plan Details")]
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        _vm._l(_vm.planColumns, function(col, ci) {
                          return _c(
                            "v-col",
                            {
                              key: ci,
                              class:
                                ci === 0
                                  ? "pl-4 pr-md-9 py-0"
                                  : "pl-md-9 pr-4 py-0",
                              attrs: {
                                cols: "12",
                                md: "6"
                              }
                            },
                            _vm._l(col, function(row) {
                              return _c(
                                "div",
                                {
                                  key: row.label,
                                  staticClass:
                                    "d-flex align-center vds-detail-row"
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "font-weight-bold mr-auto"
                                    },
                                    [_vm._v(_vm._s(row.label) + ":")]
                                  ),
                                  row.sharing
                                    ? [
                                        _vm.billing &&
                                        (_vm.billing.sharedaccount ||
                                          _vm.billing.sharedaccess)
                                          ? _c("shared-service-tag", {
                                              staticClass: "vds-plan-link",
                                              attrs: {
                                                service: _vm.billing
                                              }
                                            })
                                          : _c(
                                              "router-link",
                                              {
                                                staticClass: "vds-plan-link",
                                                attrs: {
                                                  to: {
                                                    name: "profile_access"
                                                  }
                                                }
                                              },
                                              [_vm._v("Enable Sharing")]
                                            )
                                      ]
                                    : [
                                        row.dot
                                          ? _c(
                                              "v-icon",
                                              {
                                                staticClass: "pb-1 mr-1",
                                                attrs: {
                                                  small: "",
                                                  color: row.dot,
                                                  "aria-hidden": "true"
                                                }
                                              },
                                              [_vm._v("mdi-circle")]
                                            )
                                          : _vm._e(),
                                        row.value
                                          ? _c(
                                              "span",
                                              {
                                                class: {
                                                  "vds-detail__value--muted":
                                                    row.muted
                                                }
                                              },
                                              [_vm._v(_vm._s(row.value))]
                                            )
                                          : _vm._e(),
                                        row.to
                                          ? _c(
                                              "router-link",
                                              {
                                                staticClass: "vds-plan-link",
                                                class: {
                                                  "ml-4": row.value
                                                },
                                                attrs: {
                                                  to: row.to
                                                }
                                              },
                                              [_vm._v(_vm._s(row.link))]
                                            )
                                          : row.action
                                          ? _c(
                                              "a",
                                              {
                                                staticClass: "vds-plan-link",
                                                class: {
                                                  "ml-4": row.value
                                                },
                                                attrs: {
                                                  href: "#"
                                                },
                                                on: {
                                                  click: function click(
                                                    $event
                                                  ) {
                                                    $event.preventDefault()
                                                    return row.action($event)
                                                  }
                                                }
                                              },
                                              [_vm._v(_vm._s(row.link))]
                                            )
                                          : _vm._e()
                                      ]
                                ],
                                2
                              )
                            }),
                            0
                          )
                        }),
                        1
                      ),
                      _c("gg-modal", {
                        attrs: {
                          "is-active": _vm.autorenew.ineligible
                        },
                        on: {
                          close: function close($event) {
                            _vm.autorenew.ineligible = false
                          }
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "toolbar",
                            fn: function fn() {
                              return [_vm._v("Enabling auto renew error")]
                            },
                            proxy: true
                          },
                          {
                            key: "body",
                            fn: function fn() {
                              return [
                                _vm._v(
                                  "Your service is not eligible to enable auto renew. Please contact Billing for assistance."
                                )
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "actions",
                            fn: function fn() {
                              return [
                                _c(
                                  "gg-btn",
                                  {
                                    on: {
                                      click: function click($event) {
                                        _vm.autorenew.ineligible = false
                                      }
                                    }
                                  },
                                  [_vm._v("Close")]
                                )
                              ]
                            },
                            proxy: true
                          }
                        ])
                      }),
                      _c("gg-modal", {
                        attrs: {
                          "is-active": _vm.autorenew.confirm
                        },
                        on: {
                          close: function close($event) {
                            _vm.autorenew.confirm = false
                          }
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "toolbar",
                            fn: function fn() {
                              return [_vm._v("Enabling auto renew")]
                            },
                            proxy: true
                          },
                          {
                            key: "body",
                            fn: function fn() {
                              return [
                                _c("p", [
                                  _vm._v(
                                    "This service will be set to auto-renew. Our system will automatically renew your account to ensure your account stays active."
                                  )
                                ]),
                                _c("p", [
                                  _vm._v(
                                    "Are you sure you want to enable auto renewal?"
                                  )
                                ])
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "actions",
                            fn: function fn() {
                              return [
                                _c(
                                  "gg-btn",
                                  {
                                    attrs: {
                                      secondary: ""
                                    },
                                    on: {
                                      click: function click($event) {
                                        _vm.autorenew.confirm = false
                                      }
                                    }
                                  },
                                  [_vm._v("No")]
                                ),
                                _c(
                                  "gg-btn",
                                  {
                                    attrs: {
                                      primary: "",
                                      loading: _vm.autorenew.loading
                                    },
                                    on: {
                                      click: _vm.enableAutorenewNow
                                    }
                                  },
                                  [_vm._v("Yes")]
                                )
                              ]
                            },
                            proxy: true
                          }
                        ])
                      }),
                      _vm.billing
                        ? _c("renew-now-modal", {
                            ref: "renewNowModal",
                            attrs: {
                              "service-id": _vm.billing.id
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }